const styles = () => ({
  salesPipeline: {
    '& .VictoryContainer': {
      '& svg': {
        overflow: 'visible !important',
      },
    },
  },
});

export default styles;
